import { render } from "./BookCard.vue?vue&type=template&id=12490ad0&scoped=true"
import script from "./BookCard.vue?vue&type=script&lang=js"
export * from "./BookCard.vue?vue&type=script&lang=js"

import "./BookCard.vue?vue&type=style&index=0&id=12490ad0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12490ad0"]])

export default __exports__